<template>
  <!-- Note: move http calls to Vuex -->
  <div class="container-fluid">
    <div class="amr_ls h-100 bg-white">
      <div class="row">
        <div class="col-lg-6">
          <p class="font-weight-bold d-inline">MPRN:</p>
          <p class="d-inline ml-2">{{activeMeter.Mprn}}</p>
        </div>
        <div class="col-lg-6">
          <p class="font-weight-bold d-inline">Serial Number:</p>
          <p class="d-inline ml-2">{{activeMeter.Serial}}</p>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-6">
          <p class="font-weight-bold d-inline">Reading Date:</p>
          <div class="form-group">
            <div>
              <el-date-picker
                v-model="pickerDate"
                format="dd.MM.yyyy"
                value-format="yyyy-MM-dd"
                class="float-right"
                type="date"
                placeholder="Select an end date"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </div>
          </div>
        </div>
        <div class="col-lg-6 no-pad-lg">
          <p class="font-weight-bold d-inline">Reading Sources:</p>
          <div class="btn-group d-block w-100">
            <div class="form-group">
              <select
                v-model="source"
                class="form-control"
                name="selection"
                required
              >
                <option value="AgreedOpeningRead">Agreed Opening Read</option>
                <option value="Derived">Derived</option>
                <option value="GasCardRead">Gas Card Read</option>
                <option value="MeterReadOrganisation">Meter Read Organisation</option>
                <option value="PointOfSaleRead">Point of Sale Read</option>
                <option value="RemoteReadingEquipmentRead">Remote Reading Equipment Read</option>
                <option value="Shipper">Shipper</option>
                <option value="SuppliedByEndUser">Supplied by End User</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <p class="font-weight-bold d-inline">Reading Reason:</p>
          <div class="btn-group d-block w-100">
            <div class="form-group">
              <select
                v-model="reason"
                class="form-control"
                name="reason"
                required
              >
                <option value="OpeningReading">Opening Reading</option>
                <option value="ReplacementOpeningReading">Replacement Opening Reading</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- If it is Gas readings section -->
      <div class="row">
        <!-- Left section for entering reading -->
        <div class="col-xl-6 mt-3">
          <p class="font-weight-bold d-inline">New Reading:</p>
          <!-- gas enter reading input -->
          <div class="mrs mt-2">
            <div class="d-flex justify-content-center ml-2">
              <readingInput
                ref="readingInput"
                :digits="activeMeter.Dials"
                @setReading="setReading"
              />
            </div>
          </div>
        </div>
        <!-- Right section for displaying reading info and readings -->
        <!-- last reading info -->
        <div class="col-xl-6 mt-3" v-if="activeMeter.LatestReading">
          <p class="font-weight-bold d-inline">Latest Reading:</p>
          <div class="d-inline my-auto">
            <span
              class="ml-2"
              v-if="activeMeter.LatestReading.ReadingDate"
            >{{activeMeter.LatestReading.ReadingDate | shortDate}}</span>
            <span
              v-if="diff(activeMeter.LatestReading.ReadingDate) > 25"
              class="text-danger font-weight-bold ml-1"
            >({{diff(activeMeter.LatestReading.ReadingDate) | suffix}})</span>
            <span
              v-else-if="diff(activeMeter.LatestReading.ReadingDate) <= 25"
              class="text-success font-weight-bold ml-1"
            >({{diff(activeMeter.LatestReading.ReadingDate) | suffix}})</span>
          </div>
          <div class="d-inline my-auto">
            <span>
              -
              {{activeMeter.LatestReading.ReadingType| splitString}}
            </span>
          </div>
          <!-- gas current reading input -->
          <div class="mrs mt-2">
            <div class="d-flex justify-content-center ml-2">
              <input
                v-for="(digit, index) in latestReading"
                :key="index"
                class="form-control form-control-lg font-weight-bold at_input mt-4 mr-2"
                type="text"
                maxlength="1"
                readonly
                :value="digit"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- This is when a reading doesn't look normal and within the guidelines -->
      <!-- start -->
      <div
        v-if="!isValid && fullyPopulated && validationAttempted"
        class="row"
      >
        <div class="col-12 mt-3">
          <div class="row">
            <div class="col-2 my-auto text-center">
              <img src="@/assets/img/warning_icon.png" class="d-inline" alt="Danger" />
            </div>
            <div class="col-10 my-auto">
              <p class="d-inline">This isn't consistent with a value we'd expect for:</p>
              <p class="d-inline ml-2">{{date | shortDate()}}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!isValid && fullyPopulated && validationAttempted"
        class="row"
      >
        <div class="col-12 mt-3">
          <div class="row">
            <div class="col-10 offset-2">
              <p class="d-inline">Submit anyway</p>
              <div class="d-inline">
                <span class="d-inline ml-2">
                  <label class="form-check-label radio_style" for="acceptingMeterReading">
                    <input
                      type="checkbox"
                      class="form-check-input radio_style"
                      id="acceptingMeterReading"
                      name="optradio"
                      v-model="override"
                    />
                    <span class="default"></span>
                  </label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <button
            type="submit"
            class="btn btn-hc mt-4"
            @click="submit"
            :disabled="submitStatus === 'PENDING'"
          >Submit Reading</button>
        </div>
      </div>
      <!-- End -->
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { required } from "vuelidate/lib/validators";
// import Vue from "vue";
import { uuid } from "vue-uuid";

// Components
import readingInput from "./ReadingInput";

// Mixins
import _filters from "@/mixins/filters.js";
import snotifyHttpError from "@/mixins/snotifyHttpResponses";

export default {
  name: "add-gas-reading",
  mixins: [snotifyHttpError, _filters],
  components: { readingInput },
  data() {
    return {
      submitStatus: null,
      source: "SuppliedByEndUser",
      reason: "Other",
      pickerDate: moment().format("YYYY-MM-DD"),
      pickerOptions: {
        disabledDate(date) {
          return date > moment();
        },
      },
      validationAttempted: false,
    };
  },
  validations: {
    source: {
      required,
    },
    reason: {
      required,
    },
    date: {
      required,
    },
  },
  methods: {


    setReading(reading) {
      this.reading = reading;
    },

    validateReading() {
      // Needs refactoring - Move http call to Vuex and split successful and unsuccessful actions into seperate methods.
      if (this.reading != undefined) {
        this.submitStatus = "PENDING";
        let that = this;

        this.$snotify.async(
          "Validating reading...",
          () =>
            new Promise((resolve, reject) => {
              this.$http
                .post(
                  "https://" +
                    that.$config.honeycomb.readingsbot.gas.domain +
                    "/api/v1/readings/validate",
                  {
                    SharedId: uuid.v1(),
                    ReadingDate: this.date,
                    MeterReading: this.reading,
                    Mprn: this.activeMeter.Mprn,
                    Serial: this.activeMeter.Serial,
                    ReadingSource: this.source.replace(/\s/g, ""),
                  },
                  {
                    withCredentials: true,
                  }
                )
                .then((response) => {
                  this.submitStatus = "OK";
                  if (response.data.hasOwnProperty("IsValid")) {
                    this.isValid = response.data.IsValid;
                    this.override = false;
                    if (response.data.IsValid) {
                      this.validationAttempted = true;
                      that.proceedWithSubmission();
                      resolve({
                        body: "Reading validated.",
                        config: {
                          closeOnClick: true,
                          timeout: 2000,
                        },
                      });
                    } else {
                      this.validationAttempted = true;
                      reject({
                        body: "Reading invalid.",
                        config: {
                          closeOnClick: true,
                          timeout: 3000,
                        },
                      });
                    }
                  }
                })
                .catch((error) => {
                  this.submitStatus = "ERROR";
                  this.isValid = false;
                  this.override = false;
                  this.validationAttempted = true;
                  reject(this.snotifyHttpError(error));
                });
            })
        );
      } else {
        this.submitStatus = "PENDING";
      }
    },

    diff: function (readingDate) {
      return moment().diff(readingDate, "days");
    },

    proceedWithSubmission() {
      this.submitStatus = "PENDING";

      let reading = {
        MeterConfigSharedId: this.activeMeter.MeterConfigSharedId,
        MeterReading: this.reading,
        Mprn: this.activeMeter.Mprn,
        ReadingDate: this.date,
        ReadingSource: this.source.replace(/\s/g, ""),
        Serial: this.activeMeter.Serial,
        SharedId: uuid.v1(),
        OverrideTolerances: this.override,
        ReadingReason: this.reason,
        // Hard coded underneath as entering a COT reading doesn't use this component
        IsChangeOfTenancy: false,
      };

      let that = this;
      this.$snotify.async(
        "Adding reading...",
        () =>
          new Promise((resolve, reject) => {
            // Note: Move this http request to Vuex
            this.$http
              .post(
                `https://${that.$config.honeycomb.readingsbot.gas.domain}/api/v1/readings`,
                reading,
                { withCredentials: true }
              )
              .then(() => {
                this.submitStatus = "OK";
                resolve({
                  body: "Success! Reading added!",
                  config: {
                    closeOnClick: true,
                    timeout: 2000,
                  },
                });
                this.isValid = true;
                this.override = false;
                this.pickerDate = moment().format("YYYY-MM-DD");
                this.source = "SuppliedByEndUser";
                this.reason = "Other";
                this.$store.commit("updateReading", undefined);
                this.validationAttempted = false;
                this.$refs.readingInput.clearInput();
                this.$store.dispatch("refreshReadings");
                this.$store.dispatch("refreshServiceList");
                this.$store.dispatch("refreshLatestReading");
              })
              .catch((error) => {
                this.submitStatus = "ERROR";
                reject(this.snotifyHttpError(error));
              });
          })
      );
    },

    submit() {
      // Collect all validation warnings
      let warnings = [];
      
      if (this.reading === undefined || this.reading === null) {
        warnings.push("Reading not provided.");
      }
      if (!this.isValid && this.validationAttempted && !this.override) {
        warnings.push("Submit anyway not selected.");
      }
      
      // If there are warnings, show them all at once
      if (warnings.length > 0) {
        this.$snotify.warning(warnings.join('\n\n'));
        return;
      }
      
      if (!this.validationAttempted) {
        this.validateReading();
        return;
      }
      
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.proceedWithSubmission();
      }
    },
  },
  computed: {
    date() {
      return moment.utc(this.pickerDate).format();
    },
    
    reading: {
      get() {
        return this.$store.state.meters.reading;
      },
      set(reading) {
        this.$store.commit("updateReading", reading);
      },
    },

    isValid: {
      get() {
        return this.$store.state.meters.isValid;
      },
      set(bool) {
        this.$store.commit("updateIsValid", bool);
      },
    },

    override: {
      get() {
        return this.$store.state.meters.override;
      },
      set(bool) {
        this.$store.commit("updateOverride", bool);
      },
    },
    
    activeMeter() {
      return this.$store.state.meters.activeMeter;
    },
    
    latestReading() {
      if (this.activeMeter) {
        return this.activeMeter.LatestReading.MeterReading.toString(10)
          .padStart(this.activeMeter.Dials, "0")
          .split("")
          .map(Number);
      }
    },

    fullyPopulated() {
      if (this.reading === undefined || this.reading === null) {
        return false;
      }
      const readingStr = this.reading.toString();
      return readingStr.length === this.activeMeter.Dials;
    },
  },
  watch: {
      reading: {
      handler() {
        // Reset validation state when any reading changes
        if (this.validationAttempted) {
          this.validationAttempted = false;
          this.submitStatus = "";
        }
      },
      deep: true
    }
  }
};
</script>